<div class="search_header">
  <mat-form-field appearance="outline" class="searchbar" subscriptSizing="dynamic">
    <input
      #searchInputElement
      matInput
      type="search"
      [placeholder]="'GLOBALSEARCH.SEARCHTITLE' | translate"
      [formControl]="searchInput" />

    <div matSuffix class="searchbar_suffix">
      @if (searchInput.value) {
        <button
          matIconButton
          class="searchbar_clear"
          [attr.aria-label]="'GLOBALSEARCH.CLEAR' | translate"
          (click)="searchInput.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (deviceScannerService.isSupported) {
        <button
          *hasPermission="['READ', 'device']"
          matIconButton
          class="searchbar_scanner"
          [matTooltip]="'GLOBALSEARCH.SCANNER.TOOLTIP' | translate"
          [attr.aria-label]="'GLOBALSEARCH.SCANNER.TOOLTIP' | translate"
          (click)="openScanner()">
          <mat-icon>qr_code_scanner</mat-icon>
        </button>
      }
    </div>
  </mat-form-field>
</div>

@if (searchInput.value && $displayResults()) {
  <mat-dialog-content class="content">
    <div class="lists_container">
      <!-- CATEGORIES -->

      <div class="categories">
        @if (!$isMobile()) {
          <p class="categories_label">{{ 'GLOBALSEARCH.CATEGORIES' | translate }}</p>
        }
        <div
          class="category_container"
          [ngClass]="{ active_category: !$selectedEntityId() }"
          (click)="onEntityClick(null)">
          <div class="content_container">
            <mat-icon class="icon">select_all</mat-icon>
            <p>{{ 'COMMON.ALL' | translate }}</p>
          </div>
          <div matListItemLine class="count_chip" [class]="{ active_chip: !$selectedEntityId() }">
            {{ $totalCount() }}
          </div>
        </div>
        @for (folder of $folders(); track folder.id) {
          <button
            class="category_container"
            [ngClass]="{ active_category: $selectedEntityId() === folder.id }"
            (click)="onEntityClick(folder.id)"
            *hasPermission="['READ', folder.permissionTab]"
            [style.color]="this.$disabledEntities()[folder.id] ? 'var(--text-disabled)' : ''"
            [disabled]="this.$disabledEntities()[folder.id]">
            <div class="content_container">
              <mat-icon class="icon">{{ folder.icon }}</mat-icon>
              <p>{{ folder.label | translate }}</p>
            </div>
            <div
              matListItemLine
              class="count_chip"
              [ngClass]="{ active_chip: $selectedEntityId() === folder.id }">
              {{ folder.searchResults.length }}
            </div>
          </button>
        }
      </div>

      <!-- RESULTS -->
      @defer {
        <div class="results_list">
          @if ($totalCount() > 0) {
            @if ($selectedEntity()) {
              <!-- ONE SELECTED ENTITY -->
              @if ($selectedEntity().searchResults.length) {
                <result-list [folder]="$selectedEntity()" (onSelectResult)="onSelectResult()" />
              } @else {
                <no-result-found noResultMessage="GLOBALSEARCH.NO_FOUND_RESULT_ENTITY" />
              }
            } @else {
              <!-- ALL ENTITIES -->

              @for (folder of $folders(); track folder.id) {
                @if (folder.searchResults.length) {
                  <div *hasPermission="['READ', folder.permissionTab]">
                    <div class="result_subHeader">
                      <span>{{ folder.label | translate }}</span>
                      <span class="count_chip">{{ folder.searchResults.length }}</span>
                    </div>
                    <result-list [folder]="folder" (onSelectResult)="onSelectResult()" />
                  </div>
                }
              }
            }
          } @else {
            <no-result-found noResultMessage="GLOBALSEARCH.CANNOT_FIND_RESULT" />
          }
        </div>
      }
    </div>
  </mat-dialog-content>
}

@if (searchInput.value) {
  <mat-dialog-actions class="search_footer">
    <mat-slide-toggle
      class="search_footer-toggle"
      labelPosition="before"
      [checked]="!$disabledEntities()['addresses']"
      (change)="toggleSearchAddress()">
      <span class="search_footer-toggle-label">
        {{ 'GLOBALSEARCH.SEARCHBAR_EXTRA' | translate }}
      </span>
    </mat-slide-toggle>
  </mat-dialog-actions>
}
